import { render, staticRenderFns } from "./serviceProvider.vue?vue&type=template&id=6a977b6f&scoped=true&"
import script from "./serviceProvider.vue?vue&type=script&lang=ts&"
export * from "./serviceProvider.vue?vue&type=script&lang=ts&"
import style0 from "./serviceProvider.vue?vue&type=style&index=0&id=6a977b6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a977b6f",
  null
  
)

export default component.exports